// extracted by mini-css-extract-plugin
export default {"layout":"About_layout__qZ7um","spec":"About_spec__gH1GX","prose":"About_prose__l9QQp","body":"About_body__AOoFX"};